module.exports = __webpack_public_path__ + "media/components/country-flag/static/gb-b93b144656d4ed63c65920f20d525086.svg";